import React, { useState, useEffect, useRef } from "react";
import DataTable from "../../../../Components/UiComponents/DataTable";
import { all, filter } from "../../../../Services/toolService";
import { Dialog } from "primereact/dialog";
import { getCustomerControlField } from "../../../../Services/customerServices";
import HeaderSearchBar from "../../../../Components/UiComponents/HeaderSearchBar";
import ButtonElement from "../../../../Components/UiComponents/ButtonElement";
import "react-toastify/dist/ReactToastify.css";
import { getStages } from "../../../../Services/optionService";
// Components
import CreateNewPrompts from "./CreateNewPrompts";
import EditPrompts from "./EditPrompts";
import ToastElement from "../../../../Components/UiComponents/ToastElement";
// Services
import { get } from "../../../../Services/customerServices";
import { list } from "../../../../Services/branchService";
import { findById, multiDelete } from "../../../../Services/toolService";
import Loader from "../../../../Components/UiComponents/Loader";
import { useNavigate } from "react-router-dom";
import PlaylistVideos from "../../../../Components/Videos/PlaylistVideos";
import { getCustomerFields } from "../../../../Services/fieldsServices";

export default function Prompts(props) {
    const [customerId, setCustomerId] = useState(null);
    const [custmerReferenceData, setCustmerReferenceData] = useState([]);
    const [visible, setVisible] = useState(false);
    const [visibleEdit, setVisibleEdit] = useState(false);
    const [position, setPosition] = useState('center');
    const [customerControlFields, setCustomerControlFields] = useState(null);
    const [searchQuery, setSearchQuery] = useState("");
    const [stages, setStages] = useState([]);
    const [updatedReferenceData, setUpdatedReferenceData] = useState([]);
    const [deleteProductDialog, setDeleteProductDialog] = useState(false);
    const toast = useRef(null);
    const [customerOptions, setCustomerOptions] = useState({});
    const [deletePromptsIds, setDeletePromptsIds] = useState([]);
    const [editPrompt, setEditPrompt] = useState([]);
    const [promptTabs, setPromptTabs] = useState([]);
    const toastRef = useRef();
    const [totalRecords, setTotalRecords] = useState(0);
    const navigate = useNavigate()
    const [lazyParams, setLazyParams] = useState({
        first: 0,
        rows: 10,
        page: -1,
        sortField: 'display_name',
        sortOrder: 1
    });
	const [loading, setLoading] = useState(false);
    const [deleted, setDeleted] = useState(false);
    const [showVideo, setShowVideo] = useState(false);
    const [havingBranch, setHavingBranch] = useState(false);
    const [branchIdFromLS, setBranchIdFromLS] = useState();


    useEffect(() => {
        if (deleted) {
            setDeleted(false);
            setDeletePromptsIds([])
            setUpdatedReferenceData([])
        }
    }, [deleted])

    useEffect(() => {
        // Fetching end user data from local storage
        const enduserStr = localStorage.getItem("enduser");

        // Checking if end user data exists in local storage
        if (enduserStr) {
            // Parsing end user data
            const enduser = JSON.parse(enduserStr);

            // Extracting customer information from end user data
            const customer = enduser.customer;

            // Setting customer ID state
            setCustomerId(customer);

            const branch = enduser.branch;
            setBranchIdFromLS(branch)
        } else {
            navigate("/login")
            localStorage.clear()
          }

        // Fetching stage data
        getStage();


    }, []);

    useEffect(() => {
        // Fetching customer field data
        getCustomerField();

        // Fetching customer control data
        getCustomerControl();
        getCustomerBranch()
        getCustomer();
        getBranchList();
    }, [customerId]);

    useEffect(() => {
        // Fetching customer field data
        getCustomerField();
    }, [lazyParams])

    // Function to get customer reference data.
    const getCustomer = async () => {
        try {
            if (customerId === null) {
                return;
            }
            if (customerId) {
                const customer = await get(customerId);
                if (customer && customer.data && customer.data.reference_data) {
                    // WinWorkStage
                    const refDataWinWorkStage = customer?.data?.reference_data?.find(item => item.option_names === 'WinWorkStage');
                    if (refDataWinWorkStage && refDataWinWorkStage.option_choice) {
                        const activeOptions = refDataWinWorkStage.option_choice.filter(option => option.status === 'active');
                        setCustomerOptions(prevState => ({
                            ...prevState,
                            WinWorkStageOtps: activeOptions
                        }));
                    }

                    // SectorV1
                    const refDataSectorV1 = customer?.data?.reference_data?.find(item => item.option_names === 'SectorV1');
                    if (refDataSectorV1 && refDataSectorV1.option_choice) {
                        const activeOptions = refDataSectorV1.option_choice.filter(option => option.status === 'active');
                        activeOptions.unshift({ label: "All", status: "active", score: 0 });
                        setCustomerOptions(prevState => ({
                            ...prevState,
                            SectorV1Opts: activeOptions
                        }));
                    }

                    // BusinessUnit
                    const refDataBusinessUnit = customer?.data?.reference_data?.find(item => item.option_names === 'BusinessUnit');
                    if (refDataBusinessUnit && refDataBusinessUnit.option_choice) {
                        const activeOptions = refDataBusinessUnit.option_choice.filter(option => option.status === 'active');
                        setCustomerOptions(prevState => ({
                            ...prevState,
                            BusinessUnitOpts: activeOptions
                        }));
                    }

                    // Services
                    const referenceDataServices = customer?.data?.reference_data?.find(item => item.option_names === 'Services');
                    if (referenceDataServices && referenceDataServices.option_choice) {
                        const activeOptions = referenceDataServices.option_choice.filter(option => option.status === 'active');
                        setCustomerOptions(prevState => ({
                            ...prevState,
                            ServicesOpts: activeOptions
                        }));
                    }

                    // Region
                    const referenceDataRegion = customer?.data?.reference_data?.find(item => item.option_names === 'Region');
                    if (referenceDataRegion && referenceDataRegion.option_choice) {
                        const activeOptions = referenceDataRegion.option_choice.filter(option => option.status === 'active');
                        setCustomerOptions(prevState => ({
                            ...prevState,
                            RegionOpts: activeOptions
                        }));
                    }

                    // RO Users
                    const referenceDataRoUser = customer?.data?.reference_data?.find(item => item.option_names === 'BDLongShotRole');
                    if (referenceDataRoUser && referenceDataRegion.option_choice) {
                        let optionList = [];
                        for (var i = 0; i < referenceDataRoUser.option_choice.length; i++) {
                            optionList.push({ 'id': i + 1, 'label': referenceDataRoUser.option_choice[i].label });
                        }
                        setCustomerOptions(prevState => ({
                            ...prevState,
                            RoUsersOpts: optionList
                        }));
                    }
                }
            }
        } catch (error) {
            toastRef.current.showToast({
                type: 'error',
                message: 'An error occurred. Please try again or Contact Admin.'
            });
        }
    }
    // Function to get branches.
    const getBranchList = async () => {
        try {
            if (customerId === null) {
                return;
            }
            if (customerId) {
                const branch = await list(customerId, 'branch_name', -1);
                if (branch && branch.data) {
                    const allBranches = branch.data.branch;
                    let optionList = allBranches.map(item => ({
                        id: item._id,
                        label: item.branch_name
                    }))
                    setCustomerOptions(prevState => ({
                        ...prevState,
                        Branches: optionList
                    }));
                }
            }
        } catch (error) {
            toastRef.current.showToast({
                type: 'error',
                message: 'An error occurred. Please try again or Contact Admin.'
            });
        }
    }


    // Function to fetch and set stages data
    const getStage = async () => {
        try {
            // Fetch stages data from API
            const stagesResponse = await getStages();

            // Log the fetched stages data

            // Extract and set stages data
            if(stagesResponse && stagesResponse.data){
                setStages(stagesResponse.data[0].option_choice);
            }
        } catch (error) {
            toastRef.current.showToast({
                type: 'error',
                message: 'An error occurred. Please try again or Contact Admin.'
            });
        }
    };


    // Function to fetch customer fields data from the server
    const getCustomerField = async () => {
        try {
            if (customerId === null) {
                return;
            }
            setLoading(true)
            // Ensure customerId is not null
            if (customerId !== null) {
                const { first, rows, sortField, sortOrder } = lazyParams;
                const skip = first;
                const limit = rows;
                const orderBy = sortOrder;
                const sortBy = sortField;
                const pattern = searchQuery || ''
                //skip, limit, cust_id, pattern, sortBy, orderBy
                const customerData = await filter(skip, limit, customerId, pattern, sortBy, orderBy)
                // Set the reference data in the state
                if(customerData && customerData.data){
                    setCustmerReferenceData(customerData?.data?.tool);
                    setTotalRecords(customerData?.data?.count);
                }
            }
        } catch (error) {
            toastRef.current.showToast({
                type: 'error',
                message: 'An error occurred. Please try again or Contact Admin.'
            });
        } finally {
            setLoading(false)
        }
    };

    // Function to fetch and set customer control fields data
    const getCustomerControl = async () => {
        try {
            if (customerId === null) {
                return;
            }
            // Check if customerId is available
            if (customerId !== null) {
                // Fetch customer control field data
                const customerData = await getCustomerControlField(customerId);
                // Extract and set customer control fields
                if(customerData && customerData.data){
                    const controlFields = customerData.data.cust[0].modules[0];
                    const promptTabs = controlFields.tabs.filter(tab => tab.tab_name === 'Prompts');
                    setPromptTabs(promptTabs[0].tables[0].headers)
                    setCustomerControlFields(controlFields);
                }
            }
        } catch (error) {
            toastRef.current.showToast({
                type: 'error',
                message: 'An error occurred. Please try again or Contact Admin.'
            });
        }
    };

    const getCustomerBranch = async () => {
        try {
            if (customerId === null) {
                return;
            }
            // Check if customerId is available
            if (customerId !== null) {
                // Fetch customer control field data
                const customerData = await getCustomerFields(customerId);
                // Extract and set customer control fields
                if(customerData && customerData.data){
                    setHavingBranch(customerData.data.havingBranch)
                }
            }
        } catch (error) {
            toastRef.current.showToast({
                type: 'error',
                message: 'An error occurred. Please try again or Contact Admin.'
            });
        }
    };

    const checkingDisplayName = (rowData) => {
        return (
            <div>
                {
                    <div>
                        {rowData.display_name != null && rowData.display_name != '' ? rowData.display_name : rowData.display_name}
                    </div>
                }
            </div>
        )
    }
    const promptType = (rowData) => {
        return (
            <div>
                {
                    <div>
                        {(rowData.tool_type)}
                    </div>
                }
            </div>
        )
    }


    const workStage = (rowData) => {
        return (
            <div>
                {
                    <div>
                        {rowData.winwork_display}
                    </div>
                }
            </div>
        );
    }
    const url = (rowData) => {
        return (
            <div>
                {
                    <div>
                        {rowData.url}
                    </div>
                }
            </div>
        )
    }

    // Define column configuration for the data table
    const columns = [
        {
            field: "display_name", // Field name for the column data
            header: promptTabs[0]?.display_name ? promptTabs[0]?.display_name : '', // Header text displayed in the table header
            body: checkingDisplayName, // Function to render the cell content for this column
            style: { width: "30%" }, // Inline style for the column
			headerClassName: "header-datatable",
			className: 'row-datatable',
            sortable: true
        },
        {
            field: "tool_type",
            header: promptTabs[1]?.display_name ? promptTabs[1]?.display_name : '',
            body: promptType,
			headerClassName: "header-datatable",
			className: 'row-datatable',
            sortable: true
        },
        {
            field: "winwork_display",
            header: promptTabs[2]?.display_name ? promptTabs[2]?.display_name : '',
            body: workStage,
			headerClassName: "header-datatable",
			className: 'row-datatable',
            sortable: true
        },
        {
            field: "url",
            header: promptTabs[3]?.display_name ? promptTabs[3]?.display_name : '',
            body: url,
			headerClassName: "header-datatable",
			className: 'row-datatable',
            sortable: true
        }
    ];
    const show = (position) => {
        setPosition(position);
        setVisible(true);
    };

    const showEdit = (position) => {
        setPosition(position);
        setVisibleEdit(true);
    };

    const rowClick = async (data) => {
        try {
            if (data?._id) {
                const pmptData = await findById(data._id);
                if(pmptData && pmptData.data){
                    setEditPrompt(pmptData.data);
                    showEdit('right');
                }
            }
        } catch (error) {
            toastRef.current.showToast({
                type: 'error',
                message: 'An error occurred. Please try again or Contact Admin.'
            });
        }
    };

    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value);
        setLazyParams({
            ...lazyParams,
            first: 0, // Reset to first page on new search
            page: 0
        });
        filteredQuestionsArray(e.target.value)
    };
    const handleClearFilter = () => {
        setSearchQuery("");
        setLazyParams({
            ...lazyParams,
            first: 0, // Reset to first page on new search
            page: 0
        });
        getCustomerField()
    };

    /**
    * Filters the customer reference data based on the provided query.
    * If the query is empty, it retrieves the full customer field data.
    * 
    * @param {string} query - The search query to filter the customer reference data.
    */
    const filteredQuestionsArray = (query) => {
        // Check if the query is not empty
        if (query.length > 0) {
            // Convert the query to lowercase for case-insensitive comparison
            const lowerCaseQuery = query.toLowerCase();

            // Filter the customer reference data
            const filteredData = custmerReferenceData.filter(item => {
                // Check if any value in the item includes the query string
                return Object.values(item).some(value =>
                    value.toString().toLowerCase().includes(lowerCaseQuery)
                );
            });

            // Update the state with the filtered data
            setCustmerReferenceData(filteredData);
            
        } else {
            // If the query is empty, retrieve the full customer field data
            
            getCustomerField();
        }
    };

    const handleHide = () => {
        setVisible(false);
        getCustomerField();
    }

    const handleHideEdit = () => {
        setVisibleEdit(false);
        getCustomerField();
    }

    const confirmDeleteProduct = () => {
        setDeleteProductDialog(true);
    };

    const deleteField = async () => {
        // Close the delete confirmation dialog
        setDeleteProductDialog(false);
        try {
            setLoading(true);
            // Delete Prompt
            const deleteResponse = await multiDelete(deletePromptsIds);
            if (deleteResponse && deleteResponse?.status === 200) {
                toastRef.current.showToast({
                    type: 'success',
                    message: `${customerControlFields?.tabs[8].display_name} Deleted Successfully`
                });
                setDeletePromptsIds([])
            } else {
                toastRef.current.showToast({
                    type: 'error',
                    message: `Error: failed to delete ${customerControlFields?.tabs[8].display_name}`
                });
            }

            getCustomerField();
            setDeletePromptsIds([])
			setUpdatedReferenceData([])
            setDeleted(true)
        } catch (error) {
            toastRef.current.showToast({
                type: 'error',
                message: 'An error occurred. Please try again or Contact Admin.'
            });
        }
        finally{
            setLoading(false);
        }
    }

    /**
    * Removes a field from the customer reference data at the specified index.
    * @param {number} selectedIndex - The index of the field to be removed.
    * @param {Object} data - The updated data to be set after removal.
    */
    const removeField = async (selectedIndex, data) => {
        // Check if the selectedIndex is valid
        if (selectedIndex === -1) {
            return;
        }

        // Create a shallow copy of the customer reference data
        const updatedReferenceDatas = [...custmerReferenceData];

        // Remove the field at the specified index
        updatedReferenceDatas.splice(selectedIndex, 1);
        // Update the state with the new data
        setUpdatedReferenceData(data);

        // selected ids for deletion
        setDeletePromptsIds(data.map(item => (
            item._id
        )))
    };

    const hideDeleteProductDialog = () => {
        setDeleteProductDialog(false);
    };


    // Define the footer for the delete product dialog with action buttons
    const deleteProductDialogFooter = () => {
        return (
          <div className="cancel-footer">
            <div className='align-center justify-end pb-0'>
              <ButtonElement label="No" className="cancel-new-button" onClick={hideDeleteProductDialog} />
              <ButtonElement type="submit" label="Yes" className="save-button" onClick={deleteField} />
            </div>
          </div>
        );
    }

    const onPage = (event) => {
    setLazyParams({
      ...lazyParams,
      first: event.first,
      rows: event.rows,
      page: event.page,
    });
  };

  const onSort = (e) => {
    let newSortField = e.sortField;
    let newSortOrder = e.sortOrder;

    // Check if the same column is clicked
    if (lazyParams.sortField === newSortField) {
        // If currently sorted ascending, switch to descending
        if (lazyParams.sortOrder === 1) {
            newSortOrder = -1; // Set to descending
        } 
        // If currently sorted descending, remove sorting
        else if (lazyParams.sortOrder === -1) {
            newSortField = null; // Remove sorting
            newSortOrder = -1; // Remove sorting
        }
    }  
    setLazyParams((prevParams) => ({
        ...prevParams,
        sortField: newSortField,
        sortOrder: newSortOrder,
    }));
};

    const handleButtonClick = () => {
        setShowVideo(true);
    };

    const closeVideo = () => {
        setShowVideo(false);
    };

    return (
        <div className="group-table-component">
            <ToastElement ref={toastRef} />
            <Loader loading={loading} />
            <div className="header-design">
                <div>
                    <p className="fs-16 fw-600 mar-b-3">{customerControlFields?.tabs[8].display_name}</p>
                </div>
                <ButtonElement className="upload-button" type="button" icon="pi pi-video" onClick={handleButtonClick}></ButtonElement>
                {/* <ButtonElement className="upload-button" type="button" icon="pi pi-question" /> */}
            </div>
            <div className="group-table-buttons">
				<div className="delete-button">
					{
						updatedReferenceData.length > 0 &&
						<ButtonElement
							className="delete-button-icon"
							type="button"
							icon="pi pi-trash"
							onClick={() => confirmDeleteProduct()}
						/>
					}
				</div>
				<div className="group-table-search">
					<HeaderSearchBar
						value={searchQuery}
						onChange={(e) => handleSearchChange(e)}
                        onClick={handleClearFilter}
					/>
					<ButtonElement
						className="clear-filter-button"
						type="button"
						icon="pi pi-plus"
						label="New"
						onClick={() => show("right")}
					/>
				</div>
			</div>

            <CreateNewPrompts visible={visible} position={position} customerId={customerId} customerControlFields={customerControlFields} onHide={handleHide} customerOptions={customerOptions} havingBranch={havingBranch} branchIdFromLS={branchIdFromLS}/>
            <EditPrompts visible={visibleEdit} position={position} customerId={customerId} customerControlFields={customerControlFields} editPrompt={editPrompt} onHide={handleHideEdit} customerOptions={customerOptions} havingBranch={havingBranch} branchIdFromLS={branchIdFromLS}/>
            <DataTable
				value={custmerReferenceData}
				columns={columns}
				searchQuery={searchQuery}
				removeField={removeField}
				rowClick={rowClick}
				dataKey="_id"
                onPage={onPage}
				isPrompts={true}
                lazyParams={lazyParams}
                totalRecords={totalRecords}
                onSort={onSort}
                deleted={deleted}
			/>
            <Dialog visible={deleteProductDialog} breakpoints={{ '960px': '75vw', '641px': '90vw' }} header="Confirm" modal footer={deleteProductDialogFooter} onHide={hideDeleteProductDialog} className="table-dialog width-32" draggable={false}>
                <div className="confirmation-content">
                    {updatedReferenceData && (
                        <span>
                            {updatedReferenceData.length > 1 ? (
                                <span className="table-description">
                                    Are you sure you want to delete{' '}
                                    {/* {updatedReferenceData.map((item, index) => (
                                        <b key={index}>{item.display_name}{index < updatedReferenceData.length - 1 ? ', ' : ''}</b>
                                    ))} */}
                                    ?
                                </span>
                            ) : (
                                <span className="table-description">
                                    Are you sure you want to delete{" "}
                                    {/* <b>{updatedReferenceData[0]?.display_name}</b> */}
                                    ?
                                </span>
                            )}
                        </span>
                    )}
                </div>
            </Dialog>

            <Dialog id="videoModal" visible={showVideo}
                    breakpoints={{
                    '1200px': '80vw',    // Larger modal on bigger screens
                    '1024px': '85vw',    // Slightly smaller for medium screens
                    '769': '90vw',     // Responsive on tablets
                    '641px': '95vw',     // Almost full-width on mobile
                    }}
                    modal className="table-dialog width-32" draggable={false} width="800px" height="500px" onHide={closeVideo}
                >
                    <div className="video-overlay">
                    <div className="video-container">
                        <PlaylistVideos playlistId={process.env.REACT_APP_CONTROL_PANEL_PLAYLIST_ID} apiKey={process.env.REACT_APP_GOOGLE_API_KEY} module="control_panel_prompts" />
                    </div>
                    </div>
                </Dialog>

        </div>
    )
}